function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup0301Ico04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.55 75.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M65.79,43.67c0,4.07-3.3,7.37-7.37,7.37s-7.37-3.3-7.37-7.37,3.3-7.37,7.37-7.37,7.37,3.3,7.37,7.37ZM30.4,49.57c0,4.07,3.3,7.37,7.37,7.37s7.37-3.3,7.37-7.37-3.3-7.37-7.37-7.37-7.37,3.3-7.37,7.37Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81,62.84v5.9M68.73,62.84v5.9M48.09,68.73v5.9M27.45,68.73v5.9M74.63,68.73v-7.54c0-2.54-1.62-4.79-4.03-5.59l-4.81-1.61-7.37,7.37-7.37-7.37M53.99,74.63v-7.54c0-2.54-1.62-4.79-4.03-5.59l-4.81-1.61-7.37,7.37-7.37-7.37-4.81,1.61c-2.41.8-4.03,3.06-4.03,5.59v7.54",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76,43.67c0,4.07,3.3,7.37,7.37,7.37s7.37-3.3,7.37-7.37-3.3-7.37-7.37-7.37-7.37,3.3-7.37,7.37Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.19,22.07c-4.65.89-8.85,5.16-8.85,11.06v.74c-.23-4-4.19-7.96-8.85-8.85M65.63,31.88c.1-.97.16-1.95.16-2.95,0-15.47-12.54-28.01-28.01-28.01S9.76,13.46,9.76,28.93c0,1,.06,1.98.16,2.95M.91,68.73v-7.54c0-2.54,1.62-4.79,4.03-5.59l4.81-1.61,7.37,7.37,7.37-7.37",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.77,19.95c-2.09-2.87-7.65-4.88-11.96-3.11-3.23,1.33-5.01,4.73-3.95,7.67,1.06,2.94,4.55,4.26,7.79,2.96,3.24-1.3,4.23-5.75,8.12-7.52ZM18.91,22.9c2.09-2.86,7.65-4.88,11.96-3.11,3.23,1.33,5.01,4.73,3.95,7.67-1.06,2.94-4.55,4.26-7.79,2.96-3.24-1.3-4.23-5.75-8.12-7.52Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup0301Ico04);
export default __webpack_public_path__ + "static/media/sezione-05-popup-03-01-ico-04.4c5007558540b47cfcd8c26da43680a8.svg";
export { ForwardRef as ReactComponent };